export const comments_5480348 = {"data":{"data":[],"links":{}}}